'use strict';

const AddressFinder = function ({ targetInputId, showAddresses = false, showLocations = true, suggestionsListId = 'suggestions-list', onSelect }) {
    const APIEndPoint = window.location.origin;
    const GET_LOCALITIES_API = APIEndPoint + "/api/addressfinder/getlocalities";
    const GET_ADDRESSES_API = APIEndPoint + "/api/addressfinder/getaddresses";
    let query = '';
    let suggestions = [];

    // Create suggestions list element
    const suggestionsList = document.createElement('ul');
    suggestionsList.id = suggestionsListId;
    suggestionsList.style.position = 'absolute';
    suggestionsList.style.zIndex = '9999';
    suggestionsList.style.listStyle = 'none';
    suggestionsList.style.padding = '0';
    suggestionsList.style.margin = '0';
    suggestionsList.style.border = '1px solid #999';
    suggestionsList.style.backgroundColor = '#fff';
    suggestionsList.style.fontSize = '13px';
    suggestionsList.style.display = 'none';
    suggestionsList.style.maxWidth = '300px'; 
    suggestionsList.style.width = 'auto'; 
    document.body.appendChild(suggestionsList);  

    // Function to update the position of the suggestions list
    const updateSuggestionsPosition = function () {
        const targetInput = document.getElementById(targetInputId);
        if (targetInput) {
            const rect = targetInput.getBoundingClientRect();
            suggestionsList.style.top = `${rect.bottom + window.scrollY}px`;
            suggestionsList.style.left = `${rect.left + window.scrollX}px`;
        }
    };

    // Hide suggestions when clicking outside the suggestionsList or input
    document.addEventListener('click', function (event) {
        const targetInput = document.getElementById(targetInputId);
        if (suggestionsList.style.display === 'block' && !suggestionsList.contains(event.target) && event.target !== targetInput) {
            suggestionsList.style.display = 'none';
        }
    });

    // Limit the rate of function execution
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    // Fetch suggestions based on search input
    const fetchSuggestions = function (input) {
        const maxResults = 10;
        let apiUrl;

        if (showLocations) {
            apiUrl = GET_LOCALITIES_API + `?query=${input}`;
        } else if (showAddresses) {
            apiUrl = GET_ADDRESSES_API + `?query=${input}`;
        }

        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "RequestVerificationToken": $("#checkloginApi [name='__RequestVerificationToken']").val()
            },
        }).then(response => response.json())  
            .then(data => {
                _AntiForgeryToken("#checkloginApi");
                if (showAddresses && data.suggestions) {
                    suggestions = data.suggestions.slice(0, maxResults).map(result => ({
                        description: result.placePrediction.text.text.replace(', Australia', ''),
                        place_id: result.placePrediction.placeId,
                    }));
                } else if (showLocations && data.localities) {
                    if (Array.isArray(data.localities.locality)) {
                        suggestions = data.localities.locality
                            .filter(result => result.latitude && result.longitude)
                            .slice(0, maxResults)
                            .map(result => ({
                                description: `${result.location} ${result.state} ${result.postcode}`,
                                place_id: result.id,
                                latitude: result.latitude,
                                longitude: result.longitude
                            }));
                    } else {
                        const locality = data.localities.locality;
                        suggestions = (locality.latitude && locality.longitude) ? [{
                            description: `${locality.location} ${locality.state} ${locality.postcode}`,
                            place_id: locality.id,
                            latitude: locality.latitude,
                            longitude: locality.longitude
                        }] : [];
                    }
                }
                renderSuggestions();
            }).catch(error => {
                _AntiForgeryToken("#checkloginApi");
                console.error("Error fetching autocomplete suggestions:", error); 
            });
    };

    const renderSuggestions = function () {
        suggestionsList.innerHTML = '';  

        if (suggestions.length > 0) {
            suggestions.forEach((suggestion, index) => {
                const listItem = document.createElement('li');
                listItem.innerHTML = highlightText(suggestion.description, query);
                listItem.onclick = () => handleSelect(suggestion);
                listItem.dataset.item = targetInputId + '-item';

                listItem.style.padding = '5px 5px';
                listItem.style.borderBottom = '1px solid #dbdbdb';
                listItem.style.cursor = 'pointer';

                listItem.onmouseenter = function () {
                    listItem.style.backgroundColor = '#1478d0';
                    listItem.style.color = '#fff';
                };
                listItem.onmouseleave = function () {
                    listItem.style.backgroundColor = '#fff';
                    listItem.style.color = '#000';
                };

                suggestionsList.appendChild(listItem);
            });
            suggestionsList.style.display = 'block'; 
        } else {
            suggestionsList.innerHTML = '';
        }

        updateSuggestionsPosition();
    };

    const getPlaceDetails = async (placeId) => {
        try {
            const response = await fetch(GET_ADDRESSES_API + "/" + placeId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "RequestVerificationToken": document.querySelector("#checkloginApi [name='__RequestVerificationToken']").value
                }
            });
            _AntiForgeryToken("#checkloginApi");  

            const data = await response.json();
            const addressComponents = data.addressComponents;
            const subpremise = getAddressComponent(addressComponents, 'subpremise', true);
            const address = getAddressComponent(addressComponents, 'street_number', true) + ' ' + getAddressComponent(addressComponents, 'route', true);
            const addressDetails = subpremise != '' ? subpremise + "/" + address : address;
            const place = {
                id: data.id,
                fullAddress: data.formattedAddress,
                latitude: data.location.latitude,
                longitude: data.location.longitude,
                address: addressDetails,
                locality: getAddressComponent(addressComponents, 'locality', true),
                postcode: getAddressComponent(addressComponents, 'postal_code', true),
                state: getAddressComponent(addressComponents, 'administrative_area_level_1', false)
            };

            return place;
        } catch (error) {
            _AntiForgeryToken("#checkloginApi");
            console.error("Error fetching data:", error);
            throw error; 
        }
    };

    const getAddressComponent = (components, type, isLongText) => {
        const component = components.find(c => c.types.includes(type));
        return component ? (isLongText ? component.longText : component.shortText) : '';
    };

    const handleSelect = async function (suggestion) {
        const targetInput = document.getElementById(targetInputId);
        if (targetInput) {
            targetInput.value = suggestion.description;
        }
        suggestionsList.innerHTML = '';
        suggestionsList.style.display = 'none';

        let place = null;

        // Check if `showAddresses` is true and call getPlaceDetails
        if (showAddresses) {
            try {
                place = await getPlaceDetails(suggestion.place_id);
                suggestion.description = place.fullAddress;
                suggestion.latitude = place.latitude;
                suggestion.longitude = place.longitude;
                //console.log("place: ", place.fullAddress);
            } catch (error) {
                console.error('Error fetching place details:', error);
            }
        }

        const event = new CustomEvent('result:select', {
            detail: {
                fullAddress: suggestion.description,
                metaData: {
                    latitude: suggestion.latitude,
                    longitude: suggestion.longitude,
                    place: place
                }
            }
        });
        targetInput.dispatchEvent(event);

        if (onSelect) {
            onSelect(suggestion.description, {
                latitude: suggestion.latitude,
                longitude: suggestion.longitude,
                place: place  
            });
        }
    };


    const highlightText = function (text, query) {
        if (!text || !query) return text;
        const parts = text.split(new RegExp(`(${query})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? `<strong>${part}</strong>` : part
        ).join('');
    };

    // Debounced input handler
    const handleInputChange = debounce(function (e) {
        query = e.target.value;
        if (query.length > 2) {
            fetchSuggestions(query);
        } else {
            suggestionsList.innerHTML = '';
            suggestionsList.style.display = 'none';
        }
    }, 300);

    const targetInput = document.getElementById(targetInputId);
    if (targetInput) {
        targetInput.addEventListener('input', handleInputChange);

        // Update the suggestion list position on page scroll or resize
        window.addEventListener('scroll', updateSuggestionsPosition);
        window.addEventListener('resize', updateSuggestionsPosition);
    } else {
        console.error(`Input with ID ${targetInputId} not found.`);
    }
};